import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { IChannel } from "@Interfaces";
import { ChannelActions } from "@Store";

const CloseEventConfirmationContent: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ py: 1 }}>
            <Typography variant="body2">
                {t("dialogs.channel.close_event_confirm_body")}
            </Typography>
        </Box>
    );
};

const CloseEventConfirmationActions: React.FC<IChannel> = (channel) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<any>();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleProceed = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            await dispatch(ChannelActions.closeChannel(channel));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Button
            onClick={handleProceed}
            variant="contained"
            size="small"
            color="secondary"
            disabled={isSubmitting}
            type="button"
        >
            {isSubmitting
                ? t("dialogs.channel.proceeding")
                : t("dialogs.channel.proceed")}
        </Button>
    );
};

export default {
    content: CloseEventConfirmationContent,
    actions: CloseEventConfirmationActions,
    title: "Close event?",
};
